<template>
  <div dir="rtl" style="text-align: right; padding-right: 40px;">
    <PlasmicRootProvider :prefetchedData="this.prefetchedData" :loader="this.loader">
      <PlasmicComponent component="Homepage" />
    </PlasmicRootProvider>
    <div v-if="error">
      <p><strong>ברוכים הבאים לפורטל המידע של מחלקת מערכות מידע גולדן דרגון ישראל.</strong></p>
      <p><span>מטרת הפורטל להנגיש מידע למרכזי השירות בצורה מקוונת על מנת שיוכלו לתת שירות טוב ללקוחותינו ולשפר את איכות
          השירות.</span></p>
      <p><span>בפורטל זה ניתן לקבל מידע בתחומים שונים, כל קטגוריה/לשונית מנוהלת לפי הרשאות,</span><span>&nbsp;כלומר לא
          בהכרח
          כל משתמש חשוף לכל הקטגוריות.</span></p>
      <br />
      <p class="pr-5"><span style="text-decoration: underline;"><strong>מחירון חלפים</strong></span></p>
      <p class="pr-5"><span>בקטגוריה זו ניתן לראות את כל החלפים שחברתנו מספקת למרכזי השירות, כגון:</span></p>
      <p class="pr-5"><span>מק"ט, תיאור מוצר ,מחיר ,תמונת המוצר ,זמינות במלאי והאם יש תחליפיים.</span></p>
      <br />
      <p class="pr-5"><span style="text-decoration: underline;"><strong>נתוני רכבים</strong></span></p>
      <p class="pr-5"><span>בקטגוריה זו תוכלו לראות את נתוני האוטובוס בכללי, כולל הורדה של קטלוג לפי שיוך לשלדה
          המתאימה.</span></p>
      <br />
      <p class="pr-5"><span style="text-decoration: underline;"><strong>ספריה של מדריכים בתחום מערכות
            המידע</strong></span>
      </p>
      <p class="pr-5"><span>בקטגוריה זו ניתן לראות ולהוריד את המדריכים להפעלת תוכנת הפריוריטי בעולמות התוכן של עולם
          התביעות
          והזמנת החלפים.</span></p>
      <br />
      <p class="pr-5"><span style="text-decoration: underline;"><strong>ניהול הוראות של המחלקה הטכנית</strong></span></p>
      <p class="pr-5"><span>בקטגוריה זו ניתן לראות ולהוריד הוראות לפי חלוקה למכלולים + הוראות כלליות.</span></p>
      <br />
      <p class="pr-5"><span style="text-decoration: underline;"><strong>ספרי נהג</strong></span></p>
      <p class="pr-5"><span>בקטגוריה זו ניתן לראות ספר נהג לפי דגם כולל אפשרות להורדה.</span></p>
      <br />
      <p class="pr-5"><span style="text-decoration: underline;"><strong>סטטוס תביעה</strong></span></p>
      <p class="pr-5"><span>בקטגוריה זו ניתן לראות לכל מרכז שרות את סטטוס התביעה כולל סכומים מאושרים.</span></p>
      <br />
      <p class="pr-5"><span style="text-decoration: underline;"><strong>היסטוריה ארצית לרכב</strong></span></p>
      <p class="pr-5"><span>למוסכים שיש להם גישה מוגבלת למערכות פריוריטי כאשר חשוב לציין שאין תחליף למידע שיש במערכת
          פריוריטי בהשוואה שיש בפורטל זה, ניתן לראות היסטוריה על סמך כרטיסים שנסגרו לחשבוניות במערכות מידע שיש ברשותם תכנה
          של תבל (נשר).</span></p>
      <br />
      <br />
      <p><span>בפורטל הושקע המון זמן ותכנון לגבי תוכן הנגשת המידע.</span></p>
      <p><span>נשמח לדעת איזה מידע הייתם רוצים לקבל עוד ואנו נבדוק ונוסיף במידת הצורך.</span></p>
      <p><span>ליצירת קשר יש לפנות לאמיר ג׳אבר (אחראי מערכות מידע)</span></p>
      <p><span>0545238870</span></p>
      <p><span>amirj@goldenbus.co.il</span></p>
    </div>
  </div>
</template>

<script>
import { PlasmicRootProvider, PlasmicComponent } from '@plasmicapp/loader-vue';
import { PLASMIC } from '../plasmic-init';

export default {
  name: 'Home',
  data() {
    return {
      prefetchedData: null,
      error: false
    }
  },
  components: {
    PlasmicRootProvider,
    PlasmicComponent
  },
  computed: {
    loader() {
      return PLASMIC;
    }
  },
  created() {
    PLASMIC.fetchComponentData('/', 'Homepage').then(data => this.prefetchedData = data).catch(() => {
      this.error = true;
    });
  }
}
</script>
